import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as authApi from '../../api/auth';
import { getErrorMessage } from '../../utils/apiError';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await authApi.esqueciSenha(email);
      setEnviado(true);
    } catch (err) {
      setErro(getErrorMessage(err, 'Erro ao solicitar redefinição de senha.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="sf-login">
      <div className="sf-login-brand">
        <div className="sf-login-lockup">
          <svg width="112" height="112" viewBox="0 0 64 64" fill="none" aria-hidden="true">
            <rect x="1" y="1" width="62" height="62" rx="18" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.18)" strokeWidth="1.5" />
            <rect x="15" y="17" width="34" height="9" rx="4.5" fill="#f4e389" />
            <rect x="15" y="29.5" width="24" height="9" rx="4.5" fill="#ffffff" opacity="0.92" />
            <rect x="15" y="42" width="34" height="9" rx="4.5" fill="#ffffff" opacity="0.55" />
          </svg>
          <span className="sf-login-lockup-name">StoreFlow</span>
        </div>
        <div className="sf-login-brand-footer">StoreFlow · DataFit</div>
      </div>

      <div className="sf-login-panel">
        <div className="sf-login-card">
          {enviado ? (
            <>
              <h1>Verifique seu e-mail</h1>
              <div
                className="sf-login-alert mb-3"
                style={{ background: 'var(--sf-primary-light)', borderColor: '#cfe0d0', color: 'var(--sf-primary-dark)' }}
              >
                <i className="bi bi-envelope-check" />
                Se <strong>{email}</strong> estiver cadastrado, você vai receber um link em instantes. O link
                expira em 30 minutos e só funciona uma vez.
              </div>
              <Link to="/login" className="sf-login-submit" style={{ textDecoration: 'none' }}>
                <i className="bi bi-arrow-left" />
                Voltar para o login
              </Link>
            </>
          ) : (
            <>
              <h1>Esqueci minha senha</h1>
              <p style={{ margin: '-14px 0 20px', fontSize: 13.5, color: 'var(--sf-text-muted)' }}>
                Informe o e-mail cadastrado — vamos te mandar um link para criar uma senha nova.
              </p>

              <form className="sf-login-form" onSubmit={handleSubmit}>
                {erro && (
                  <div className="sf-login-alert">
                    <i className="bi bi-exclamation-circle" />
                    {erro}
                  </div>
                )}

                <label className="sf-field-label">
                  <span>E-mail</span>
                  <span className="sf-field">
                    <i className="bi bi-envelope" />
                    <input
                      type="email"
                      placeholder="voce@empresa.com"
                      required
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </span>
                </label>

                <button type="submit" className="sf-login-submit" disabled={enviando}>
                  {enviando ? 'Enviando...' : 'Enviar link de redefinição'}
                  {!enviando && <i className="bi bi-arrow-right" />}
                </button>
              </form>

              <div className="sf-login-footnote" style={{ justifyContent: 'center' }}>
                <Link to="/login" className="sf-field-link">
                  <i className="bi bi-arrow-left me-1" />
                  Voltar para o login
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
